import React, { useState, useEffect } from 'react';
import { Select, InputNumber, Slider, Input, Button, Form, Row, Col } from 'antd';
import './ElementContainer.css';
import cls from '../cls.json';

const { Option } = Select;

const GenerateAnalogsComponent = ({ onGenerate, constantSmiles, variableSmiles }) => {
  const [mainCls, setMainCls] = useState('');
  const [minCls, setMinCls] = useState('');
  const [minClsOptions, setMinClsOptions] = useState([]);
  const [generateRound, setGenerateRound] = useState(1);
  const [number, setNumber] = useState(5);
  const [jobName, setJobName] = useState('AIFragGen');
  const [delta, setDelta] = useState('');
  const [deltaValue, setDeltaValue] = useState('');

  useEffect(() => {
    if (delta === '-1') {
      setDeltaValue('(-10.5, -8.5]');
    }
    else if (delta === '1') {
      setDeltaValue('(8.5, 10.5]');
    }
  }, [delta]); 

  const handleMainClsChange = (value) => {
    setMinCls('');
    setMainCls(value);
    setMinClsOptions(cls[value]);
    
  };

  const handleGenerate = () => {
    const data = {
      "constSmiles": constantSmiles,
      "varSmiles": variableSmiles,
      "mainCls": mainCls,
      "minorCls": minCls,
      "deltaValue": deltaValue,
      "num": number,
    };
    onGenerate(data);
  };

  return (
    <div className="element-container">
      <div className='title' style={{ textAlign: 'left' }}>
        <label htmlFor="generateAnalogs">Generate analogs</label>
      </div>
      
      <Form layout="vertical" style={{ marginTop: '20px' }}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Main Cls">
              <Select value={mainCls} onChange={value => handleMainClsChange(value)}>
                <Option value="activity">Activity</Option>
                <Option value="toxicity">Toxicity</Option>
                <Option value="metabolism">Metabolism</Option>
                <Option value="absorption">Absorption</Option>
                <Option value="excretion">Excretion</Option>
                <Option value="distribution">Distribution</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Minor Cls">
            <Select value={minCls} onChange={value => setMinCls(value)}>
              {minClsOptions.map((option, index) => (
                <Select.Option key={index} value={option}>
                  {option}
                </Select.Option>
              ))}
            </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Number">
              <InputNumber
                min={1}
                max={100}
                value={number}
                onChange={value => setNumber(value)}
              />
              <Slider
                min={1}
                max={10}
                value={number}
                onChange={value => setNumber(value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>

          <Col span={8} style={{alignItems: 'flex-end'}}>
            
            <Form.Item label="Delta Value">
              <Select value={delta} onChange={value => setDelta(value)}>
                <Option value="-1">Negative</Option>
                <Option value="1">Positive</Option>
                
              </Select>
            </Form.Item>
          </Col>
            
          {/* TODO: 后续使用再放开 */}
          {/* <Col span={8} style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Form.Item label="Job Name" style={{ flex: 1 }}>
              <Input value={jobName} onChange={e => setJobName(e.target.value)} />
            </Form.Item>
          </Col> */}

          <Col span={8} style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Form.Item style={{ flex: 1 }}>
              <Button type="primary" onClick={handleGenerate} block>
                Generate
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default GenerateAnalogsComponent;

